// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(function(i){return i[1]});
// Module
___CSS_LOADER_EXPORT___.push([module.id, "\n.w-partner-content[data-v-2616d49b] {\n  position: relative;\n}\n.w-partner-left-icon[data-v-2616d49b] {\n  position: absolute;\n  left: -30px;\n  top: 45%;\n  margin-top: -14px;\n  z-index: 1;\n}\n.w-partner-right-icon[data-v-2616d49b] {\n  position: absolute;\n  right: -30px;\n  top: 45%;\n  margin-top: -14px;\n  z-index: 1;\n}\n", ""]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
module.exports = ___CSS_LOADER_EXPORT___;
